const EVENT_SERVICE_BASE = "/gateway/api/event-service"

export const API_ADD_USER = `${EVENT_SERVICE_BASE}/iam/accounts`;
export const API_GET_LIST_USER = `${EVENT_SERVICE_BASE}/iam/accounts`;
export const API_GET_LIST_ROLE = `${EVENT_SERVICE_BASE}/iam/roles`;
export const API_UPDATE_USER = `${EVENT_SERVICE_BASE}/iam/accounts`;
export const API_DELETE_USER = `${EVENT_SERVICE_BASE}/iam/accounts`;
export const API_GET_PERMISSION = `${EVENT_SERVICE_BASE}/iam/permissions`;
